import { FIELD_KINDS, } from './enums';
/** Platform default text style (new templates, ad-hoc documents, previews). */
export const DEFAULT_TEXT_STYLE = {
    font: 'Inter',
    size: 12,
    color: '#111827',
    align: 'left',
};
export class SnapshotParseError extends Error {
    constructor(message) {
        super(message);
        this.name = 'SnapshotParseError';
    }
}
function isRecord(v) {
    return typeof v === 'object' && v !== null && !Array.isArray(v);
}
/**
 * Runtime guard for a `fieldsSnapshot` blob read back from the database. The
 * column is untyped JSON, so this is the ONE place a stored snapshot is checked
 * before code starts trusting `kind`, ids and geometry. Throws a descriptive
 * `SnapshotParseError` rather than letting a corrupt blob surface as a
 * `TypeError` deep inside the stamp engine.
 */
export function parseSnapshot(json, at = 'fieldsSnapshot') {
    if (!Array.isArray(json)) {
        throw new SnapshotParseError(`${at}: expected an array of fields, got ${json === null ? 'null' : typeof json}`);
    }
    json.forEach((f, i) => {
        if (!isRecord(f)) {
            throw new SnapshotParseError(`${at}[${i}]: expected a field object, got ${typeof f}`);
        }
        if (typeof f.kind !== 'string' || !FIELD_KINDS.includes(f.kind)) {
            throw new SnapshotParseError(`${at}[${i}].kind must be one of ${FIELD_KINDS.join(', ')} (got ${JSON.stringify(f.kind)})`);
        }
        if (typeof f.id !== 'string' || !f.id) {
            throw new SnapshotParseError(`${at}[${i}].id must be a non-empty string`);
        }
        for (const prop of ['page', 'x', 'y', 'w', 'h']) {
            if (typeof f[prop] !== 'number' || !Number.isFinite(f[prop])) {
                throw new SnapshotParseError(`${at}[${i}].${prop} must be a finite number`);
            }
        }
    });
    return json;
}
//# sourceMappingURL=fields.js.map